import i18n from "../../i18n";

export interface CSVType {
    key: string,
    apiType: string,
    title: string
}

export function getCSVType() : Record<string, CSVType> {
    return Object.freeze({
        CODED_VALUES: { key: "CODED_VALUES", apiType: "CodedValues", title: i18n.t("csv.coded-values") },
        FINANCIAL_CALENDAR: {key: "FINANCIAL_CALENDAR", apiType: "FinancialCalendar", title: i18n.t("csv.financial-calendar") },
        CUSTOMER_PADE: {key: "CUSTOMER_PADE", apiType: "CustomerPADE", title: i18n.t("csv.customer-pade") },
        OUTLET_TARGET: {key: "OUTLET_TARGET", apiType: "OutletTarget", title: i18n.t("csv.outlet-level-target") },
        ROUTE_TARGET: {key: "ROUTE_TARGET", apiType: "RouteTarget", title: i18n.t("csv.sales-route-target") },
        SUPPRESSION_CODES: {key: "SUPPRESSION_CODES", apiType: "SuppressionCodes", title: i18n.t("csv.suppression-codes") },
        ROUTE_PADE: {key: "ROUTE_PADE", apiType: "RoutePADE", title: i18n.t("csv.route-pade") },
        CALL_CYCLE: {key: "CALL_CYCLE", apiType: "CallCycle", title: i18n.t("csv.call-cycle") },
        IC_EXCLUSION: {key: "IC_EXCLUSION", apiType: "ICExclusion", title: i18n.t("csv.ic-exclusion") },
        SELLING_WEEK: {key: "SELLING_WEEK", apiType: "SellingWeek", title: "Selling Week" }, // Check if can be removed
        CATEGORY_TARGET: {key: "CATEGORY_TARGET", apiType: "CategoryTarget", title: i18n.t("csv.category-target") },
        CDE_TARGET: {key: "CDE_TARGET", apiType: "CDETarget", title: i18n.t("csv.cde-target") },
        USER_ROUTES: {key: "USER_ROUTES", apiType: "UserRoutes", title: i18n.t("route.route-assignment") },
        BI_EGRESS: {key: "BI_EGRESS", apiType: "BIEgress", title: i18n.t("csv.bi-egress") }
    });
}